<template>
  <div
    v-show="linksCount > -1"
    class="row sift-links-wrap"
  >
  <!-- todo; update classes for this component -->
  <!-- from sift-links to sift-results -->

    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12 col-md-12">
          <h3 class="heading heading--h4 text-medium mt-30">{{ website.title ? website.title : website.uri }}</h3>
        </div>

        <div class="col-xs-12 col-md-4 col-lg-3">
          <img :src="website.imageUri !== 'undefined' ? website.imageUri : placeholder" @error="setPlaceholder" alt="" />
        </div>

        <div class="col-xs-12" :class="{'col-md-4 col-lg-4': website.imageUri !== 'undefined'}">
          <p class="paragraph text-small paragraph--desc">{{ website.description !== 'undefined' ? website.description : 'There is no description related to this site.' }}</p>
        </div>

        <div class="col-xs-12 col-md-7">
          <h3 class="heading heading--h6 text-bold mt-30">Keywords</h3>
          <p class="paragraph">{{ website.keywords !== 'undefined' ? website.keywords : 'There are no keywords related to this site.' }}</p>
        </div>
      </div>
    </div>

    <div class="sift-links col-xs-12" v-if="linksCount > 0">
      <h3 class="heading heading--h6 text-bold mt-30">
        Sift results
      </h3>

      <filters />

      <LinkList
        v-if="filteredLinks"
        :payload="filteredLinks"
      />

      <div class="row middle-xs sift-links__try-again">
        <div class="col-xs-12">
          <p class="paragraph no-margin text-center">
            Want to sift another link? <a href="" @click="tryAgain">Try again!</a>
          </p>
        </div>
      </div>
    </div>

    <div class="col-xs-12 sift-links__no-results" v-else>
      <p class="paragraph text-center">
        Unfortunately your sift did not result in any links. <a href="" @click="tryAgain">Try again?</a>
      </p>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import eventBus from '@/event-bus';
import Filters from '@/components/Filters/Filters.vue';
import LinkList from '@/components/LinkList/LinkList.vue';

export default {
  name: 'SiftResults',
  components: {
    LinkList,
    Filters,
  },
  data() {
    return {
      theBigFive: [
        'facebook',
        'amazon',
        'amzn.to',
        'google',
        'apple',
        'microsoft',
        'instagram',
        'youtu.be',
        'instagrm',
        'twitter',
        'pinterest',
        'fb.me',
      ],
      placeholder: '/assets/placeholder.png',
    };
  },
  computed: {
    ...mapGetters({
      website: 'UrlInput/siftedWebsite',
      linksCount: 'UrlInput/siftedWebsiteLinksCount',
      relative: 'Filters/allowRelative',
      bigFive: 'Filters/allowBigFive',
      fullUrl: 'Filters/allowfullUrl',
    }),
    filteredLinks() {
      const vm = this;
      const links = this.website.links.slice().filter((link) => {
        const isBigFive = vm.theBigFive.some(l => link.websiteUri.includes(l));

        if (isBigFive && !vm.bigFive) {
          return false;
        }

        if (link.isRelative && !vm.relative) {
          return false;
        }

        return true;
      });

      if (!vm.fullUrl) {
        const fullUrlLinks = [];

        links.forEach((link) => {
          const existing = fullUrlLinks.slice().filter(l => l.websiteUri === link.websiteUri && !vm.relative);
          if (existing.length === 0) {
            const newLink = JSON.parse(JSON.stringify(link));
            if (!vm.relative) newLink.displayUri = link.websiteUri;
            fullUrlLinks.push(newLink);
          }
        });

        return fullUrlLinks;
      }

      return links;
    },
  },
  created() {
    eventBus.$on('showSiftResults', () => {
      this.$nextTick(() => {
        this.$smoothScroll({ scrollTo: this.$el, offset: -73 });
      });
    });
  },
  methods: {
    ...mapMutations({
      clearLinks: 'UrlInput/clearLinks',
    }),
    tryAgain(e) {
      e.preventDefault();
      eventBus.$emit('tryAgain');
      this.clearLinks();
    },
    cleanUri(uri) {
      return uri ? uri.replace('https://', '').replace('http://', '') : uri;
    },
    setPlaceholder(e) {
      e.target.src = this.placeholder;
    },
  },
};
</script>
